module.exports = __webpack_public_path__ + "static/media/combo_s.9a22edc3.png";